module.exports = __webpack_public_path__ + "img/agri.14878403.jpg";